export const cssBundleHref = "https://cx-resources.oddschecker.com/public/build/css-bundle-CXW2K46W.css";